import { render, staticRenderFns } from "./WkDashboard.vue?vue&type=template&id=3bd9d84b"
import script from "./WkDashboard.vue?vue&type=script&lang=js"
export * from "./WkDashboard.vue?vue&type=script&lang=js"
import style0 from "./WkDashboard.vue?vue&type=style&index=0&id=3bd9d84b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports